import type { User } from '@/modules/shared/types'

interface ApiAuthUser {
  userId: string
  email: string
  role: string
  displayName: string | null
  emailVerified: boolean
  needsPassword?: boolean
}

export type ApiClaimResponse =
  | {
      action: 'authenticated'
      token: string
      user: ApiAuthUser
      storeId: number
      storeName: string
      memberRole: string
      needsPassword: boolean
    }
  | { action: 'login_required'; email: string; storeName: string; memberRole: string }
  | { action: 'signup_required'; email: string; storeName: string }

export type ClaimResult =
  | {
      action: 'authenticated'
      token: string
      user: User
      storeId: number
      storeName: string
      memberRole: string
      needsPassword: boolean
    }
  | { action: 'login_required'; email: string; storeName: string; memberRole: string }
  | { action: 'signup_required'; email: string; storeName: string }

// mapUser mirrors mapApiUser in auth.api.ts but is injected to avoid a cycle.
export function mapClaimResult(
  res: ApiClaimResponse,
  mapUser: (u: ApiAuthUser) => User = defaultMapUser,
): ClaimResult {
  if (res.action !== 'authenticated') return res
  return { ...res, user: mapUser(res.user) }
}

function defaultMapUser(u: ApiAuthUser): User {
  return {
    id: u.userId,
    email: u.email,
    name: u.displayName ?? u.email,
    role: u.role === 'admin' ? 'admin' : 'member',
    organizationId: '',
  }
}
